module.exports = __webpack_public_path__ + "static/media/ribbon-left.b7b1f1a9.png";